// extracted by mini-css-extract-plugin
module.exports = {"view":"appointments__BookAppointmentView__view"};